import type { CategoryContent } from '../row.js';

export const ITALIAN_HISTORY: CategoryContent = {
  bscba: [
    [
      'Welke Italiaanse stadstaat werd de dominante maritieme macht in de Middellandse Zee en controleerde handelsroutes naar het Oosten vanaf de 9e eeuw?',
      [
        'Venetië',
        'Genua',
        'Florence',
        'Milaan',
      ],
      0,
      'Venetië bouwde een uitgebreid maritiem rijk en handelsnetwerk dat tot de Napoleontische verovering de Middellandse Zee domineerde.',
    ],
    [
      'De rijkdom en Renaissance-mecenaat van de familie Medici waren gecentreerd in welke Italiaanse stad?',
      [
        'Florence',
        'Venetië',
        'Rome',
        'Napels',
      ],
      0,
      'De Medici regeerden Florence als handelaren en bankiers, waardoor zij kunstenaars steunden en pausen en koninginnen voortbrachten.',
    ],
    [
      'Wat is de term voor de 19e-eeuwse Italiaanse nationalistische beweging die het schiereiland verenigde?',
      [
        'Risorgimento',
        'Restaurazione',
        'Renouveau',
        'Republica',
      ],
      0,
      'Risorgimento ("wederopstanding") verenigde Italië vanuit fragmentatie en beëindigde eeuwen van buitenlandse overheersing.',
    ],
    [
      'Welke militaire generaal leidde vrijwilligers om Sicilië en Napels in 1860-1861 te veroveren?',
      [
        'Giuseppe Garibaldi',
        'Victor Emmanuel II',
        'Camillo Cavour',
        'Luigi Settimbrini',
      ],
      0,
      'Garibaldi\'s Duizenden veroverden Sicilië en Napels, waardoor de politieke eenheid van het koninkrijk rechtstreeks mogelijk werd.',
    ],
    [
      'Welke Piemontese staatsman organiseerde de diplomatieke en politieke eenheid van Italië?',
      [
        'Camillo Cavour',
        'Giuseppe Mazzini',
        'Giuseppe Garibaldi',
        'Victor Emmanuel II',
      ],
      0,
      'Cavour, minister-president van Piëmont, gebruikte allianties en diplomatie om Piëmont als centrum van eenheid te positioneren.',
    ],
    [
      'In welk jaar werd het Koninkrijk Italië officieel uitgeroepen?',
      [
        '1861',
        '1848',
        '1815',
        '1870',
      ],
      0,
      'Het Koninkrijk Italië werd op 17 maart 1861 onder Victor Emmanuel II uitgeroepen, hoewel Rome pas in 1870 werd geïncorporeerd.',
    ],
    [
      'Welke dictator kwam aan de macht in Italië via de Mars op Rome in 1922?',
      [
        'Benito Mussolini',
        'Victor Emmanuel III',
        'Francesco Crispi',
        'Luigi Facta',
      ],
      0,
      'Mussolini\'s Zwarthemden marcheerden in 1922 op Rome, waardoor de koning hem benoemde tot minister-president.',
    ],
    [
      'Welke grote gebeurtenis in 1870 voltooide de Italiaanse territoriale eenheid?',
      [
        'Italiaanse troepen veroverden Rome',
        'Paus Pius IX sloot zich vrijwillig aan bij het koninkrijk',
        'Internationale mogendheden gaven Rome aan Italië',
        'Het Vaticaan sloot een vredesverdrag',
      ],
      0,
      'In 1870 doorbraken Italiaanse troepen de muren van Rome. Dit beëindigde de pauselijke wereldlijke macht en voltooide de eenheid.',
    ],
    [
      'In welk jaar werd de Italiaanse Republiek opgericht, ter vervanging van de monarchie?',
      [
        '1946',
        '1943',
        '1948',
        '1950',
      ],
      0,
      'Een referendum in juni 1946 schrapte de monarchie; Italië\'s nieuwe grondwet trad in werking in januari 1948.',
    ],
    [
      'Welke vreemde mogendheid domineerde veel van Italië in de 16e en 17e eeuw via koninkrijken en stadstaatcontrole?',
      [
        'Spanje',
        'Frankrijk',
        'Oostenrijk',
        'Het Ottomaanse Rijk',
      ],
      0,
      'Spanje regeerde Zuid-Italië en hield Milaan na de Italiaanse Oorlogen, en domineerde zo twee eeuwen lang het schiereiland.',
    ],
    [
      'Na de Napoleontische Oorlogen, welke vreemde mogendheid hield Lombardije en Venetië?',
      [
        'Oostenrijk',
        'Frankrijk',
        'Rusland',
        'Pruisen',
      ],
      0,
      'Oostenrijk controleerde Lombardije en Venetië, waardoor het de belangrijkste hinderpaal voor Noord-Italiaanse eenheid werd.',
    ],
    [
      'Welke revolutionair stichtte Jong Italië, een geheime beweging die eenheid bevorderde?',
      [
        'Giuseppe Mazzini',
        'Camillo Cavour',
        'Victor Emmanuel II',
        'Niccolò Machiavelli',
      ],
      0,
      'Mazzini richtte in 1831 Jong Italië op om nationalistische actie aan te sporen, hoewel zijn republicanisme het uiteindelijk verloor van Cavours monarchie.',
    ],
    [
      'Welk Noord-Italiaans koninkrijk werd het politieke en militaire centrum van eenheid?',
      [
        'Piëmont',
        'Lombardije',
        'Venetië',
        'Savoye',
      ],
      0,
      'Piëmont, onder het Huis Savoye, had Italië\'s sterkste leger en duidelijkste eenheidsvisie.',
    ],
    [
      'Welke Middellandse Zee-stadstaat was behalve Venetië een beroemde middeleeuwse en Renaissance maritieme macht?',
      [
        'Genua',
        'Amalfi',
        'Pisa',
        'Salerno',
      ],
      0,
      'Genua rivaliseerde met Venetië als maritieme republiek en controleerde de handel in de Middellandse Zee en de Zwarte Zee.',
    ],
    [
      'Welk verdrag in 1929 loste de "Romeinse Vraag" op door de onafhankelijkheid van Vaticaanstad vast te stellen?',
      [
        'Lateraansverdrag',
        'Verdrag van Rome',
        'Conciliair Akkoord',
        'Pauselijk Handvest',
      ],
      0,
      'Het Lateraansverdrag creëerde Vaticaanstad als onafhankelijke staat en beëindigde pauselijke territoriale geschillen.',
    ],
  ],
  msc: [
    [
      'Waarom prevaleert Cavours monarchistische aanpak uiteindelijk over Mazzini\'s republicaans ideaal?',
      [
        'Realisme won van idealisme',
        'Republieken waren inherent instabiel',
        'Het pausdom eiste een monarchie',
        'Mazzini controleerde het leger',
      ],
      0,
      'Cavour\'s pragmatische diplomatie en Piëmont\'s macht versloegen Mazzini\'s federalistische republicanisme.',
    ],
    [
      'Onder het Verdrag van Turijn (1860) wat cedeerde Piëmont aan Frankrijk?',
      [
        'Nice en Savoye',
        'Piëmont zelf',
        'Lombardije en Venetië',
        'Sicilië en Napels',
      ],
      0,
      'Cavour verhandelde Nice en Savoye voor Frankrijk, waardoor hij cruciale steun tegen Oostenrijk verkreeg.',
    ],
    [
      'Het conflict tussen Mazzini\'s visie en Cavour\'s strategie resulteerde in welk gevolg?',
      [
        'Constitutionele monarchie, geen republiek',
        'Italië werd een kerkelijke theocratie',
        'Italië splitste in onafhankelijke republieken',
        'Mazzini\'s model werd universeel aanvaard',
      ],
      0,
      'Cavour\'s realisme beveiligde eenheid als monarchie onder het Huis Savoye.',
    ],
    [
      'De Italiaanse Oorlogen (1494-1559) ontstonden vooral uit rivaliteit tussen welke twee mogendheden?',
      [
        'Spanje en Frankrijk',
        'Venetië en het Pausdom',
        'Oostenrijk en Pruisen',
        'Ottomaanse Rijk en Venetië',
      ],
      0,
      'Habsburgers (Spanje) en Valois (Frankrijk) vochten voor Italiaanse controle, waardoor het schiereiland verdeeld bleef.',
    ],
    [
      'Welk geslacht regeerde het Koninkrijk der Twee Siciliën (Napels en Sicilië) na 1713?',
      [
        'Het Huis Bourbon',
        'Het Huis Valois',
        'Het Huis Habsburg',
        'Het Huis Oranje',
      ],
      0,
      'Bourbonkoningen regeerden Napels en Sicilië als welvarend koninkrijk, apart van Noord-Italië.',
    ],
    [
      'Welke Verlichtingsjurist schreef een verhandeling over misdaad en straf die de Europese wetgeving hervormde?',
      [
        'Cesare Beccaria',
        'Giovanni Vico',
        'Niccolò Machiavelli',
        'Antonio Genovesi',
      ],
      0,
      'Beccaria\'s werk uit 1764 tegen foltering en doodstraf beïnvloedde de moderne strafwetgeving.',
    ],
    [
      'Het Congres van Wenen (1815) fragmenteerde Italië opzettelijk onder Oostenrijkse dominantie. Wat was Metternich\'s doel?',
      [
        'Om toekomstige eenheid te voorkomen',
        'Italië onmiddellijk te eenigen',
        'Een Italiaanse republiek in te stellen',
        'Pauselijke wereldlijke macht te herstellen',
      ],
      0,
      'Metternich\'s Weense regeling bracht Italië terug tot fragmentatie om nationalistische uitdagingen te voorkomen.',
    ],
    [
      'Wie commandeerde Italiaanse troepen die Rome in 1870 veroverden?',
      [
        'Generaal Cadorna',
        'Giuseppe Garibaldi',
        'Koning Victor Emmanuel II',
        'Camillo Cavour',
      ],
      0,
      'Generaal Cadorna\'s troepen doorbraken de muren van Rome, wat een einde maakte aan de pauselijke wereldlijke macht.',
    ],
    [
      'Italië\'s alliantie met Pruisen in 1866 in de Austro-Pruisische Oorlog stelde het in staat welk grondgebied te verwerven?',
      [
        'Venetië',
        'Piëmont',
        'Toscane',
        'Sicilië',
      ],
      0,
      'Pruisische overwinning stelde Italië in staat Venetië te veroveren, het laatste grote Italiaanse grondgebied van Oostenrijk.',
    ],
    [
      'Het Lateraansverdrag (1929) stelde wat in met betrekking tot de pauselijke status?',
      [
        'Vaticaanstad, onafhankelijk onder de Paus',
        'Volledige pauselijke herstel van de Pauselijke Staten',
        'Gezamenlijk bestuur van Rome door Paus en Italië',
        'Volledige scheiding van kerk en staat',
      ],
      0,
      'Het verdrag creëerde Vaticaanstad en loste de "Romeinse Vraag" van pauselijke onafhankelijkheid op.',
    ],
    [
      'Mussolini\'s Pact of Steel uit 1939 met nazi-Duitsland verbond Italië waaraan?',
      [
        'Onvoorwaardelijke steun aan Duitsland',
        'Fusie van Italiaanse en Duitse regeringen',
        'Overdracht van Italiaanse koloniën aan Duitsland',
        'Onmiddellijke aanvaarding van nazi-rassenwetten',
      ],
      0,
      'Het Pact of Steel bond Italië militair aan Duitsland, wat leidde tot betrokkenheid bij de Tweede Wereldoorlog.',
    ],
    [
      'Na Italië\'s wapenstilstand met de Geallieerden in 1943 welke marionettenstad stichtte Duitsland in het noorden?',
      [
        'De Italiaanse Sociale Republiek',
        'De Voorlopige Italiaanse Regering',
        'Het Noord-Italiaans Koninkrijk',
        'De Fascistische Democratische Republiek',
      ],
      0,
      'Duitsland creëerde de Italiaanse Sociale Republiek als nazimarionettenstaat in bezet Noord-Italië.',
    ],
    [
      'Welk corruptieschandaal in de late jaren 1980 en vroege jaren 1990 destabiliseerde de Eerste Republiek?',
      [
        'Tangentopoli',
        'Mafia Maxima',
        'Operazione Cristallo',
        'Scandalo Europeo',
      ],
      0,
      'Tangentopoli ("Omkoopstad") onthulde systemische corruptie en leidde tot onderzoeken die de Eerste Republiek destabiliseerden.',
    ],
    [
      'Waarom was Piëmont\'s alpine geografische positie voordelig voor eenheid?',
      [
        'Het liep dwars door de Alpen',
        'Het was de rijkste regio in Italië',
        'Het had de grootste bevolking',
        'Het werd beschermd voor alle invasies',
      ],
      0,
      'De positie van het Huis Savoye aan weerszijden van de Alpen stelde Cavour in staat om met Frankrijk te onderhandelen terwijl hij aan Italiaanse hegemonie bouwde.',
    ],
    [
      'Hoe beïnvloedde de dominantie van Piemontese en Toscaanse dialecten tijdens eenheid de Italiaanse taal?',
      [
        'Politieke macht en literair prestige',
        'De Paus bepaalde dat alleen Piemontees zou worden gesproken',
        'Alle Italianen spraken van nature dezelfde dialect',
        'Zuid-Italianen weigerden andere dialecten te leren',
      ],
      0,
      'Piëmont\'s macht en Toscane\'s literaire prestige stelden hun varianten als basis van modern Italiaans vast.',
    ],
  ],
  phd: [
    [
      'Hoe institutionaliseerde de Vrede van Westfalen (1648) Italiaanse fragmentatie onder Habsburg-dualisme?',
      [
        'Verdeling tussen Oostenrijk en Spanje',
        'Het verleende Frankrijk volledige dominantie over Italië',
        'Het herstelde het Romeinse Rijk onder pauselijk gezag',
        'Het stichtte het eerste verenigde Italiaanse koninkrijk',
      ],
      0,
      'De Vrede van Westfalen sloot Italië op in Habsburgse controle en fragmenteerde het schiereiland tot de Napoleontische periode.',
    ],
    [
      'Wat was de strategische doctrine achter Metternich\'s opzettelijke Italiaanse fragmentatie na 1815?',
      [
        'Verenigd Italië zou Oostenrijkse hegemonie bedreigen',
        'Metternich geloofde dat Italië te democratisch zou worden',
        'Hij wilde pauselijke politieke macht versterken',
        'Hij ondersteunde Italiaanse onafhankelijkheid en nationalisme',
      ],
      0,
      'Metternich\'s concert rationaliseerde fragmentatie als noodzakelijk om zowel Frans als Italiaans nationalisme in te dammen.',
    ],
    [
      'Waarom hervormden de mislukte liberaal-nationalistische opstanden van 1848-1849 de Italiaanse politieke strategie?',
      [
        'Nederlaag discrediteerde de volksrevolutie',
        'De opstanden waren onmiddellijk succesvol',
        'Er was geen militaire nederlaag',
        'Italianen verwierpen nationalisme volledig',
      ],
      0,
      'De ineenstorting van 1848-49 discrediteerde volksbewegingen en opende het pad naar Cavours elitegeleide realisme.',
    ],
    [
      'Hoe divergeerde Garibaldi\'s pragmatische aanvaarding van Victor Emmanuel II van Mazzini\'s republicanisme?',
      [
        'Garibaldi zette eenheid boven ideologie',
        'Mazzini leidde monarchistische samenzweringen',
        'Garibaldi wilde het Pausdom herstellen',
        'Ze hadden identieke politieke visies',
      ],
      0,
      'Garibaldi\'s bereidheid om het Huis Savoye te accepteren maakte Cavour\'s monarchistische schikking mogelijk en isoleerde Mazzini\'s republicanisme.',
    ],
    [
      'Wat was het "Non expedit"-decreet, en hoe belemmerden het de Italiaanse natiebouw?',
      [
        'Pius IX verbood katholieken de politiek',
        'Het verplichtte katholieken eenheid te ondersteunen',
        'Het verordonneerde pauselijk gezag over heel Italië',
        'Het schrapte Italiaanse taal en cultuur',
      ],
      0,
      'Non expedit isoleerde het pausdom zestig jaar lang van het Italiaanse burgerleven en fragmenteerde de institutionele eenheid.',
    ],
    [
      'Welke structurele factoren maakten Zuid-Italië chronisch onderontwikkeld na eenheid?',
      [
        'Feodale latifundia en noordwaartse migratie',
        'Zuid-Italianen waren van nature minder capabel',
        'De Mafia veroorzaakte alleen armoedte',
        'Het Noorden had geen feodale geschiedenis',
      ],
      0,
      'Mezzogiorno\'s feodale landbouw, zwakke industrie en brigandage bleken weerbarstig tegenover Piemontese modernisering.',
    ],
    [
      'De zuidelijke "brigandage-oorlog" (1861-1876) weerspiegelde welk onderliggend sociaal conflict?',
      [
        'Onrust tegen dienstplicht en onderdrukking',
        'Spaanse indringers startten de opstanden',
        'Buitenlandse huurlingen veroorzaakten brigandage alleen',
        'Het was puur een Mafia-criminaliteit',
      ],
      0,
      'Brigandage in de Mezzogiorno weerspiegelde reële grieven op het platteland, die werden onderdrukt door harde bezetting zonder hervormingen.',
    ],
    [
      'Wat karakteriseerde Giovanni Giolitti\'s regering (1903-1914) als overgangsperiode tussen liberaal Italië en fascisme?',
      [
        'Kiesrechtsuitbreiding zonder structuurherstel',
        'Volledige afwijzing van democratie',
        'Totale alliantie met het Pausdom tegen secularisme',
        'Herstel van absolute monarchie',
      ],
      0,
      'Giolitti\'s flexibele liberalisme verbreedde het stemrecht terwijl hij de conservatieve elites in stand hield, waardoor transformatieve hervormingen stagneerden.',
    ],
    [
      'Hoe voedde de notie van "vittoria mutilata" (verminkte overwinning) wrok na de Eerste Wereldoorlog?',
      [
        'Minder gebiedswinst dan beloofd',
        'Italië verloor de hele oorlog',
        'Italië verkreeg meer dan beloofd',
        'Italië was nooit betrokken bij WWI',
      ],
      0,
      'Naoorlogse territoriale teleurstelling en nationalistische wrok creëerden condities voor Mussolini\'s fascistische opkomst.',
    ],
    [
      'Wat was de filosofische basis van Mussolini\'s corporatistische economische model?',
      [
        'Staatssyndicaten verdrongen de markt',
        'Vestiging van vrij-marktkapitalisme',
        'Herverdeling van welvaart uitsluitend aan arbeiders',
        'Herstel van feodale landbouwstelsels',
      ],
      0,
      'Italiaans corporatisme integreerde alle producenten in fascistische syndicaten en schrapte onafhankelijke markten en vakbonden.',
    ],
    [
      'Hoe verschilden Italië\'s rassenwetten van 1938 aanvankelijk van de uitvoering ervan in nazi-Duitsland?',
      [
        'Aanvankelijk minder streng dan in Duitsland',
        'Italiaanse rassenwetten waren onmiddellijk even streng',
        'Italië stelde nooit rassenwetten in',
        'Italië overtrof onmiddellijk nazi-rassenmaatregelen',
      ],
      0,
      'Italiaans fascisme nam rassenwetten aan om zich af te stemmen op nazi-Duitsland, maar sociale weerstand verzwakte de handhaving tot aan de Duitse bezetting.',
    ],
    [
      'Welke paradoxale politieke status ontstond uit Italië\'s september 1943 wapenstilstand en latere oorlogsverklaring?',
      [
        'Gesplitst: geallieerd zuiden, Duits noorden',
        'Italië trok zich vreedzaam volledig terug uit WWII',
        'Italië bleef onder Mussolini verenigd',
        'Duitsland evacueerde Italië onmiddellijk',
      ],
      0,
      'Badoglio\'s wapenstilstand splitste Italië in een geallieerd zuiden en een door Duitsland gecontroleerd noorden, wat een paradoxale medestrijderspositie creëerde.',
    ],
    [
      'Hoe hervormde de institutionele status van de Italiaanse Communistische Partij (PCI) de naoorlogse democratie?',
      [
        'De PCI bleef een legitieme oppositie',
        'De PCI greep onmiddellijk totale macht',
        'Het had geen electorale steun',
        'Het verwierp alle democratische deelname',
      ],
      0,
      'PCI\'s democratische legitimiteit voorkwam een eenpartijhegemonie en institutionaliseerde linkse inbreng in de Eerste Republiek.',
    ],
    [
      'Welk institutioneel kenmerk van de Eerste Republiek ondermijnden Tangentopoli\'s onthullingen fundamenteel?',
      [
        'Het brak "partitocrazia"',
        'Het had geen institutioneel gevolg',
        'Het versterkte de monarchie',
        'Het verminderde stemrechten',
      ],
      0,
      'Tangentopoli ontmantelde de naoorlogse partijen (DC, PSI) en leidde tot electorale hervormingen, wat een einde maakte aan het consensusmodel van de Eerste Republiek.',
    ],
    [
      'Hoe liep Petrarca\'s articulatie van humanistische deugd in de 14e eeuw vooruit op het Florentijnse burgerrepublicanisme?',
      [
        'Klassieke deugd onderbouwde de burgerideologie',
        'Petrarca vond fascisme uit',
        'Petrarca was monarchist',
        'Klassiek leren speelde geen rol in Renaissance-politiek',
      ],
      0,
      'Het Petrarcaanse humanisme legde een verband tussen tekstuele deugd en burgerbetrokkenheid, wat het Florentijnse republikeinse zelfbewustzijn ondersteunde.',
    ],
  ],
  professor: [
    [
      'Hoe vertegenwoordigde Florence\'s catasto-hervorming van 1427 technologische en bestuurlijke innovatie die de staatsopbouw hervormde?',
      [
        'Een eigendomstelling',
        'Het schrapte alle belasting',
        'Het herstelde puur feodalisme',
        'Het vond aandelenmarkten uit',
      ],
      0,
      'Catasto\'s gerationaliseerde, documentgestuurde beoordeling werd fundamenteel voor vroegmoderne staatsopbouw en fiscale controle.',
    ],
    [
      'Hoe maakte het condottieri-systeem gecentraliseerde Italiaanse staatsontwikkeling mogelijk, en hoe beperkte het die tegelijk?',
      [
        'Maakte steden militair vrij, maar verzwakte het centrale bevel',
        'Condottieri hadden geen politieke invloed',
        'Ze verenigden onmiddellijk Italië',
        'Ze schrapten alle militaire activiteit',
      ],
      0,
      'Condottieri professionaliseerden de oorlogvoering, maar fragmenteerden de militaire loyaliteit en belemmerden zo een nationale verdediging tot het tijdperk van de natiestaat.',
    ],
    [
      'Hoe veranderden het Verdrag van Utrecht (1713) en latere Bourbonregalisme de ecclesiastische-politieke balans in Napels?',
      [
        'Utrecht onderwierp kerkbenoemingen aan de staat',
        'Het Pausdom verkreeg volledige territoriale controle',
        'Ecclesiastische autoriteit werd geheel afgeschaft',
        'Het verdrag had geen politieke gevolgen',
      ],
      0,
      'Bourbonregalisme onderwierp kerkbenoemingen aan de staatsautoriteit, verminderde de pauselijke invloed en maakte Verlichtingshervormingen mogelijk.',
    ],
    [
      'Welke ideologische erfenis lieten de mislukte Jacobijnse republieken (1799-1815) na, ondanks hun militaire ineenstorting onder het Congres van Wenen?',
      [
        'Constitutionele idealen herleefden later',
        'Jacobijnisme had geen blijvende intellectuele erfenis',
        'De Jacobijnen verenigden Italië onmiddellijk',
        'Nationalisme werd na 1815 uitgevonden',
      ],
      0,
      'Hoewel militair verslagen, injecteerden Jacobijnse republieken grondwettelijke en nationalistische idealen die voortdurend herleefden.',
    ],
    [
      'Hoe week Cavour\'s realisme af van de mislukte opstanden van 1848-49, en wat was zijn kernstrategische inzicht?',
      [
        'Cavour koos diplomatie boven opstand',
        'Cavour ondersteunde uitsluitend volksrevolutie',
        'Hij verwierp alle banden met vreemde machten',
        'Hij vertrouwde alleen op diplomatieke brieven',
      ],
      0,
      'Cavour\'s pragmatische verschuiving van volksactivisme naar diplomatieke onderhandeling maakte eenheid mogelijk waar ideologie alleen faalde.',
    ],
    [
      'Wat was het strategische belang van het geheime Plombières-akkoord (1858) tussen Cavour en Napoleon III?',
      [
        'Franse steun ten koste van Nice en Savoye',
        'Plombières verbood enige Franse alliantie',
        'Het garandeerde Italië zou Franse kolonie worden',
        'Het stelde onmiddellijk pauselijk gezag vast',
      ],
      0,
      'Het Plombières-akkoord ruilde de gebieden Nice en Savoye voor beslissende Franse steun, en zette daarmee het monarchistisch-seculiere traject van de eenwording vast.',
    ],
    [
      'Hoe bemoeilijkte de structurele onderontwikkeling van het zuidelijke Mezzogiorno—geworteld in latifundia-feodalisme—de naoorlogse nationale integratie?',
      [
        'Feodale latifundia en hulpbronnenonttrekking',
        'Het Zuiden was onmiddellijk welvarend',
        'Structurele ongelijkheid kwam alleen van de Mafia',
        'Noord en Zuid waren gelijk ontwikkeld',
      ],
      0,
      'De feodale erfenis van de questione meridionale en de aanhoudende onttrekking van hulpbronnen hielden het regionale dualisme in modern Italië in stand.',
    ],
    [
      'Waarom diende Giovanni Gentile\'s filosofische actualisme, vastgelegd in de Riforma Gentile (1923), de fascistische totalitaire pedagogiek?',
      [
        'Het verhief de staat boven het individu',
        'Gentile verzette zich tegen fascisme',
        'Hij pleitte voor zuiver individualisme',
        'Zijn filosofie had geen relatie tot onderwijs',
      ],
      0,
      'Gentile\'s actualisme verschafte filosofische legitimiteit voor fascistische totalitaire pedagogie en jeugdindoctrinatie.',
    ],
    [
      'Hoe onthulden Italiaanse interneringskampen in Libië, Griekenland en de Balkan (1940-1943) een fascistische imperiale methodologie die verschilde van nazigenocide?',
      [
        'Dwangarbeid en honger, geen uitroeiing',
        'Italië stelde nooit kampen in',
        'Italiaanse sterfte was alleen van natuurlijke oorzaken',
        'Kampen waren zuiver voor criminele rehabilitatie',
      ],
      0,
      'Italiaanse interneringskampen doodden duizenden mensen door opzettelijke ontbering, en onthulden zo fascisme\'s dodelijke rassenideologie los van de nazityperingen.',
    ],
    [
      'Welke institutionele mechanismen maakten de integratie van de PCI in de consensus van de Eerste Republiek mogelijk, ondanks het anticommunisme van de Koude Oorlog?',
      [
        'Vertegenwoordiging institutionaliseerde de PCI',
        'De PCI werd onmiddellijk uitgesloten van politiek',
        'De PCI en fascisten verenigden zich',
        'Italië had geen naoorlogse democratische instellingen',
      ],
      0,
      'Proportionele vertegenwoordiging institutionaliseerde communistische deelname en maakte van de PCI een permanente oppositie die het uitvoerend gezag intoomde.',
    ],
    [
      'Hoe vormden Mussolini\'s interventie in de Eerste Wereldoorlog (1915) en de latere nederlaag de opkomende ideologie van het fascisme?',
      [
        'Wrok over de "verminkte overwinning"',
        'Italië won volledige overwinning',
        'Italië leed geen slachtoffers',
        'Naoorlogse welvaart schrapte fascisme',
      ],
      0,
      'Naoorlogse wrok en de crisis van de biennio rosso (1919-1922) creëerden een institutioneel vacuüm dat het fascisme opvulde.',
    ],
    [
      'Wat vertegenwoordigden het Verdrag van Maastricht (1992) en de invoering van de euro (1999-2002) symbolisch voor de Italiaanse naoorlogse soevereiniteit?',
      [
        'Overdracht van monetaire soevereiniteit',
        'Italië verwierp de euro permanent',
        'Maastricht had geen economisch gevolg',
        'Italië gaf vrijwillig alle soevereiniteit op',
      ],
      0,
      'De overdracht naar de euro markeerde een diepgaande heronderhandeling van de monetaire autonomie die tijdens de eenwording was vastgesteld.',
    ],
    [
      'Hoe verschilde Mazzini\'s ideologie van "guerra popolare" (volksoorlog) — een grootschalige volksopstand — van Cavour\'s elitaire diplomatieke realisme?',
      [
        'Cavour\'s diplomatie versloeg Mazzini\'s opstand',
        'Mazzini ondersteunde monarchie en Cavour republicanisme',
        'Ze hadden identieke visies',
        'Volksbewegingen slaagden onmiddellijk',
      ],
      0,
      'Mazzini\'s ideologie werd door Cavour\'s diplomatie buitengesloten, wat de monarchie institutionaliseerde boven massamobilisatie.',
    ],
    [
      'Wat onthulden Silvio Berlusconi\'s meerdere premierschappen (1994-2011) over grondwettelijke spanningen in de Tweede Republiek?',
      [
        'Belangenconflicten en corruptieprocessen',
        'Berlusconi had geen politieke invloed',
        'Hij herstelde fascisme onmiddellijk',
        'Grondwettelijk recht versterkte zich zonder controversie',
      ],
      0,
      'Berlusconi\'s media-politieke hybride en anti-institutionele retoriek testten Italië\'s grondwettelijke beperkingen.',
    ],
    [
      'Hoe hervormden het verlies van de pauselijke "wereldlijke macht" in 1870 en de oplossing daarvan in het Lateraansverdrag (1929) de kerk-staatrelaties in het verenigde Italië?',
      [
        'De breuk van 1870, opgelost in 1929',
        'Het Pausdom heroverde alle wereldlijke macht',
        'Kerk en staat werden onmiddellijk gescheiden',
        'Het Lateraansverdrag had geen gevolgen',
      ],
      0,
      'De Vaticaanstad-oplossing van het Lateraansverdrag maakte een einde aan 59 jaar kerk-staatconflict en institutionaliseerde de ecclesiastische onafhankelijkheid.',
    ],
  ],
};
